// Material Dashboard 2 PRO React helper functions
import hexToRgb from "./hexToRgb";

export function rgba(color: string | undefined, opacity?: number | undefined): string {
  return `rgba(${hexToRgb(color)}, ${opacity})`;
}

export default rgba;